import MockupList from './MockupList'

export default MockupList
